import { APP_ROUTES } from '@cpd-app/core-module/constants/routes';

/**
 * The main navigation. 00-foundations section 2, settled 2026-08-24.
 *
 * **Four destinations, and they live in the shell** so every page carries them.
 * Reachability is part of the requirement rather than a nicety: it is what
 * closes Jackson's item 8b, and 06 acceptance criterion 1 is exactly that
 * Transition and Jobs can be reached from anywhere in the app.
 *
 * Two changes from what shipped:
 *
 *  - Servicemember Resources and Counselor Resources were two destinations and
 *    are now one, **Learner and Counselor Resources**, which answers item 8c.
 *    Spec 08 makes that page hold both audiences in separate panels, because
 *    4.1.3 names them separately and does not let them collapse into one FAQ.
 *  - **Transition and Jobs** is new: spec 06.
 */
export const NAV_LINKS: {
  label: string;
  path: string;
  class: string;
  /**
   * Approved 2 Oct. What the top nav shows below 1200px wide, where the full
   * label would wrap to two lines. The visible text is the accessible name
   * at every width (WCAG 2.5.3).
   */
  shortLabel?: string;
}[] = [
  {
    label: 'Home',
    class: 'home-link',
    /*
     * The redesigned home page. This pointed at the old Build Your Target
     * page, so the nav's own Home tab took a member away from the page 02-home
     * replaces it with.
     */
    path: '/home'
  },
  {
    label: 'Quick Match',
    class: 'quick-match-link',
    path: APP_ROUTES.CareerPlanning.QuickMatch
  },
  {
    label: 'Learner & Counselor Resources',
    shortLabel: 'Resources',
    class: 'resources-link',
    // Spec 08 makes /about/resources the one destination for both audiences.
    path: APP_ROUTES.About.Resources
  },
  {
    label: 'Transition & Jobs',
    class: 'transition-link',
    path: APP_ROUTES.Transition
  }
];

export const TAKE_SURVEY_URLS = [
  '/career-planning/build-your-target/skills',
  '/career-planning/build-your-target/values',
  '/career-planning/build-your-target/lifestyle',
  '/career-planning/build-your-target/interests',
  '/career-planning/build-your-target/education',
  '/career-planning/build-your-target/other-skills',
  '/career-planning/build-your-target/career-goals',
  '/career-planning/build-your-target/education-goals'
] satisfies string[];
